import { environment } from './../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";

@Injectable()
export class GeneralConnectorService {

  constructor(
    private http: HttpClient,
  ) { }

  toggleClientReviewSms(clientCode, action) {
    const url = 'https://reviews-api.storpug.com/v1/enable-client';
    return this.http.post(url, {
      "env": environment.env,
      "clientCode": clientCode,
      "action": action
    });
  }
}



// WEBPACK FOOTER //
// ./src/ng2/app/providers/general-connector.service.ts